import { Button } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderBread from "../../../components/HeaderBread";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import { DatePicker, message } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import Download from "../../../components/Downloads";
import Logs from "../../../components/Logs";
import SwitchBar from "../../../components/Pages/SwitchBar";
import SearchField from "../../../components/SearchField";
import CustomizedTable from "../../../components/UI/CustomizedTable";
import Location from "../../../components/UI/Location";
import Vessel from "../../../components/UI/VesselFilter";
import { getAncillary } from "../../../utils/ApiCalls/Ancillary";
import { createDownloads } from "../../../utils/ApiCalls/Downloads";
import { getLeadsData } from "../../../utils/ApiCalls/Leads";
import { addlog } from "../../../utils/ApiCalls/Logs";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage/index";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import Swal from "sweetalert2";
import MemberType from "../../../components/UI/MemberFilter";
import { useDebounce } from "../../../hooks";
import { marketConsentColumn } from "../../../utils/CommonFunctions/utils";

const parseCreatedAtRange = (createdAt) => {
  if (!createdAt) return null;
  try {
    const [start, end] = JSON.parse(createdAt);
    if (start && end) return [dayjs(start, "YYYY-MM-DD"), dayjs(end, "YYYY-MM-DD")];
  } catch (e) {
    // unparsable — treat as no selection
  }
  return null;
};

const Leads = () => {
  const { RangePicker } = DatePicker;
  const navigate = useNavigate();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Failed Booking List",
      route: "/website/bookings/leads",
    },
  ];
  const [active, setActive] = useState("listing");
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [sailing_date, setSaling_date] = useState(
    () => new URLSearchParams(window.location.search).get("sailing_date") || undefined
  );
  const [columns, setColumns] = useState([]);
  const [ancillary, setAncillary] = useState();
  const [created_at, setCreatedAt] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.has("created_at")
      ? params.get("created_at")
      : JSON.stringify([
          moment().subtract(3, "months").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ]);
  });
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();
  const [locationData, setLocationData] = useState([]);
  const [locationId, setLocationId] = useState(
    () => new URLSearchParams(window.location.search).get("locationId") || ""
  );
  const [disableSpecificDate, setDisableSpecificDate] = useState([]);
  const [vessel, setVessel] = useState([]);
  const [vesselId, setVesselId] = useState(
    () => new URLSearchParams(window.location.search).get("vesselId") || ""
  );
  const [type, setType] = useState("");

  
  
    const locationP = useLocation();
  
    const [page, setPage] = useState(
      () => parseInt(new URLSearchParams(locationP.search).get("page")) || 1
    );
    const [pageSize, setPageSize] = useState(
      () => parseInt(new URLSearchParams(locationP.search).get("pageSize")) || 10
    );
  const [search, setSearch] = useState(
    () => new URLSearchParams(locationP.search).get("search") || ""
  );

  // Debounced search - delays API calls by 500ms after user stops typing
  const debouncedSearch = useDebounce(search, 500);
  const [sort, setSort] = useState();
  const [order, setOrder] = useState();

  useEffect(() => {
    const params = new URLSearchParams(locationP.search);
    const pageParam = parseInt(params.get("page")) || 1;
    const pageSizeParam = parseInt(params.get("pageSize")) || 10;
    const searchParam = params.get("search") || "";

    // setPage(pageParam);
    // setPageSize(pageSizeParam);
    setSearch(searchParam);
  }, []);  // Only run once on mount
  
  useEffect(() => {
    const params = new URLSearchParams();

    params.set("page", page);
    params.set("pageSize", pageSize);
    if (debouncedSearch) params.set("search", debouncedSearch);
    params.set("created_at", created_at);
    if (sailing_date) params.set("sailing_date", sailing_date);
    if (locationId) params.set("locationId", locationId);
    if (vesselId) params.set("vesselId", vesselId);

    const newParamsString = params.toString();

    navigate({ search: newParamsString }, { replace: true });
  }, [
    page,
    pageSize,
    debouncedSearch,
    created_at,
    sailing_date,
    locationId,
    vesselId,
    navigate,
  ]);
  


  const sortHandler = (options) => {
    if (Object.keys(options).length > 0) {
      setSort(options.columnKey);
      setOrder(
        options.order === "ascend"
          ? "asc"
          : options.order === "descend"
          ? "desc"
          : undefined
      );
      setPage(1);
    }
  };

  const dateRender = (current) => {
    const isDisabled =
      !disableSpecificDate.filter(
        (item) => item.format("YYYY-MM-DD") === current.format("YYYY-MM-DD")
      ).length > 0;
    return (
      <div
        className="ant-picker-cell-inner"
        style={{
          color: isDisabled ? "inherit" : "white",
          background: isDisabled ? "inherit" : "blue",
          borderRadius: "100px",
        }}
      >
        {current.date()}
      </div>
    );
  };

  const setPositionalValue = (data) => {};
  useEffect(() => {
    getancillaryData();
  }, []);
  const getancillaryData = async () => {
    let data = await getAncillary({ page: 1, limit: 10 });
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setAncillary(data.data);
    }
  };
  useEffect(() => {
    if (ancillary?.length)
      setColumns([
        {
          title: "Sl",
          width: 30,
          dataIndex: "id",
          key: "id",
          fixed: "left",
          render: (position, record, index) =>
            (page - 1) * pageSize + index + 1,
        },
        {
          title: "Package Id",
          dataIndex: "package_id",
          key: "package_id",
          sorter: (a, b) => "",
          width: 50,
        },
        {
          title: "Embarkation Port",
          dataIndex: "port",
          key: "port",
          width: 10,
        },
        {
          title: "Booking No",
          dataIndex: "booking_no",
          key: "booking_no",
          sorter: (a, b) => "",
        },
        {
          title: "Seaware Booking No",
          dataIndex: "temp_booking_id",
          key: "temp_booking_id",
          width: 150,
        },
        {
          title: "Cabin no",
          dataIndex: "cabin_no",
          key: "cabin_no",
          sorter: (a, b) => "",
          width: 10,
          render: (item, booking) => <div>{booking?.cabin_no ?? "--"}</div>,
        },
        {
          title: "Booking Date",
          dataIndex: "created_at",
          key: "created_at",
          sorter: (a, b) => "",
          width: 150,
          render: (item, record) => (
            <div>{moment(item).format("DD-MM-YYYY")}</div>
          ),
        },
        {
          title: "Sailing Date",
          dataIndex: "sailing_date",
          key: "sailing_date",
          sorter: (a, b) => "",
          width: 150,
          render: (item, record) => (
            <div>{moment(item).format("DD-MM-YYYY")}</div>
          ),
        },
        {
          title: "Cabin Category",
          dataIndex: "cabin_category",
          key: "cabin_category",
          sorter: (a, b) => "",
          width: 10,
          render: (item, booking) => (
            <div>{booking?.cabin_category ?? "--"}</div>
          ),
        },

        {
          title: "Passengers",
          dataIndex: "first_name",
          key: "first_name",

          width: 50,
          render: (item, record) => (
            <div>
              {record.first_name
                ? record.first_name + " " + record.last_name
                : "-"}
            </div>
          ),
        },
        {
          title: "Location",
          dataIndex: "location",
          key: "location",

          width: 10,
        },
        {
          title: "Amount",
          dataIndex: "price",
          key: "price",
          sorter: (a, b) => "",
          width: 10,
        },
        {
          title: "Cabin Charges",
          dataIndex: "cabin_charges",
          key: "cabin_charges",
          width: 120,
          render: (item) => item ?? "-",
        },
        {
          title: "Port Charges",
          dataIndex: "port_charges",
          key: "port_charges",
          width: 120,
          render: (item) => item ?? "-",
        },
        {
          title: "Ancillary Charges",
          dataIndex: "ancillary_charges",
          key: "ancillary_charges",
          width: 120,
          render: (item) => item ?? "-",
        },
        {
          title: "Discount",
          dataIndex: "referral_promo_discount",
          key: "referral_promo_discount",
          width: 150,
          render: (item) => item ?? "-",
        },
        {
          title: "Currency",
          dataIndex: "currency",
          key: "currency",
          sorter: (a, b) => "",
          width: 10,
        },
        marketConsentColumn,
        {
          title: "Rate Plan",
          dataIndex: "fare_code_name",
          key: "fare_code_name",
          sorter: (a, b) => "",
          width: 200,
          render: (item, booking) => (
            <div>
              {(booking?.fare_code_name ||
                booking?.leadDetails
                  ?.map((item) => item.fare_code_name)
                  ?.join(",")) ??
                "--"}
            </div>
          ),
        },
        {
          title: "Reason",
          dataIndex: "payment_status",
          key: "payment_status",
          sorter: (a, b) => "",
          width: 200,
          render: (text, record) => (
            <div>
              {text
                ? text == "Request was processed successfully."
                  ? "Payment Completed Booking failed"
                  : record?.cruise_type?.toLowerCase() === "seaware" ? "Booking Created,Payment Failed" : "Payment Failed"
                  : "Payment not initialized"}
            </div>
          ),
        },
        {
          title: "Cybersource Message",
          dataIndex: "payment_status",
          key: "payment_status",
          width: 200,
          render: (text, record) => (
            <div>
              {text || " "}
            </div>
          ),
        },
        {
          title: "Vessel",
          dataIndex: "vessel_name",
          key: "vessel_name",

          width: 150,
        },
        {
          title: "No Of Pax",
          dataIndex: "no_of_pax",
          key: "no_of_pax",

          width: 100,
          render: (item, record) => (
            <div>
              {Number(record.adult) +
                Number(record.child) +
                Number(record.infant)}
            </div>
          ),
        },
        ...(Array.isArray(ancillary) ? ancillary : []).map((item) => ({
          title: item.english_title,
          dataIndex: item.ancillary_code,
          key: item.ancillary_code,
          width: 10,
        })),

        {
          title: "Action",
          key: "operation",
          width: 100,
          render: (text, record) => (
            <div className="table_action_btn">
              <button
                className="btn delete_btn"
                onClick={() => handleEdit(record.id, record.cabin_no)}
              >
                <i
                  className="ri-eye-line"
                  data-toggle="tooltip"
                  title="View"
                ></i>
              </button>
            </div>
          ),
        },
      ]);
  }, [page, pageSize, debouncedSearch, sailing_date, created_at, ancillary]);

  useEffect(() => {
    getVesselData();
    if (active === "listing" && ancillary) {
      getData(page, sort, order);
    }
  }, [page, pageSize, debouncedSearch, sailing_date, created_at, sort, order]);

  const getVesselData = async () => {
    let vessels = await getVessels();
    if (vessels.error) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: vessels.error, type: "error" },
      });
    } else {
      vessels.push({ id: null, name: "All" });
      setVessel(vessels);
    }
  };

  const getData = async (value, sortBy = sort, orderBy = order) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let args = {
      search: debouncedSearch,
      page: value,
      limit: pageSize,
      sailing_date,
      created_at,
      type,
      ancillary: ancillary.map((item) => item.ancillary_code),
    };
    if (locationId) {
      args = {
        ...args,
        location_id: locationId === -1 ? undefined : locationId,
      };
    }
    if (orderBy) {
      if (sortBy) {
        args = { ...args, sort: sortBy };
      }
      args = { ...args, order: orderBy };
    }
    if (vesselId && vessel.length) {
      let selectedVessel = vessel.find(function (element) {
        return element.id == vesselId;
      });
      if (selectedVessel) {
        args = { ...args, vessel_name: selectedVessel.name };
      }
    }

    let data = await getLeadsData(args);
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setRows(data.data);
      setCount(data.count);
      setPositionalValue(data.data);
      if (data.sailingDates) {
        const sailingDates = data.sailingDates.map((e) =>
          moment(e.sailing_date)
        );
        setDisableSpecificDate(sailingDates);
      }
      if (locationData.length === 0) {
        data.locations.push({ location_id: -1, location: "ALL" });
        setLocationData(data.locations);
      }
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const handleEdit = async (id, cabin_no) => {
    navigate("/website/bookings/leads/edit/" + id + "?cabin_no=" + cabin_no);
  };
  const saveDownloads = async () => {
    if (checkPermission(permission, "download_per", "Failed Bookings",window?.location?.pathname)) {
      if (count > 0) {
        let args = { search: debouncedSearch, sailing_date, created_at };
        if (locationId) {
          args = {
            ...args,
            location_id: locationId === -1 ? undefined : locationId,
          };
        }
        if (vesselId && vessel.length) {
          let selectedVessel = vessel.find(function (element) {
            return element.id == vesselId;
          });
          if (selectedVessel) {
            args = { ...args, vessel_name: selectedVessel.name };
          }
        }
        if (
          JSON.parse(args.created_at).filter((item) => item !== "").length < 2
        ) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Need date range",
          });
          return;
        }
        let request = {
          module_name: "failed_booking",
          created_by: userDetails?.id,
          search_params: args,
        };
        if (
          JSON.parse(args.created_at).filter((item) => item !== "").length < 2
        ) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Need date range",
          });
          return;
        }
        let data = await createDownloads(request);
        if (data.error) {
          message.error("An error occurs when you try to download");
        } else {
          addlog("Bookings Downloaded", "Leads", args, userDetails.id);
          message.success("Download request submitted");
        }
      } else {
        message.error("There are no bookings to download");
      }
    } else {
      message.error("Download permission missing");
    }
  };

  return (
    <Layout type={"read_per"} module_data={"Failed Bookings"}>
      <CustomHeaderTitle title={"Failed Bookings"} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={"Failed Bookings"}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <SwitchBar
              tabs={[
                { title: "Failed Bookings List", value: "listing" },
                { value: "downloads", title: "Downloads" },
                { value: "logs", title: " History Logs" },
              ]}
              activeTab={active}
              setActiveTab={(item) => {
                setCreatedAt(
                  JSON.stringify([
                    moment().subtract(3, "months").format("YYYY-MM-DD"),
                    moment().format("YYYY-MM-DD"),
                  ])
                );
                setActive(item);
              }}
            />
            {active === "listing" && (
              <div className="card">
                <div className="card-header two_item" style={{ flexWrap: "wrap", rowGap: "10px" }}>
                  {/* <h5 className="card-title">Failed Bookings List</h5> */}
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                    <Location
                      width="150px"
                      setPage={setPage}
                      getData={getData}
                      locationData={locationData}
                      setLocationId={setLocationId}
                      locationId={locationId}
                    />
                    <Vessel
                      setVesselId={setVesselId}
                      vesselData={vessel}
                      vesselId={vesselId}
                      getData={getData}
                      setPage={setPage}
                      width={150}
                    />
                    <DatePicker
                      style={{
                        width: "150px",
                      }}
                      placeholder="Sailing Date"
                      label="Sailing Date"
                      value={sailing_date ? dayjs(sailing_date) : null}
                      onChange={(date, dateString) => {
                        setSaling_date(dateString || undefined);
                        setPage(1);
                      }}
                      dateRender={dateRender}
                      disabledDate={(current) => {
                        return !disableSpecificDate.some((date) =>
                          current.isSame(date, "day")
                        );
                      }}
                    />

                    <RangePicker
                      style={{
                        width: "250px",
                      }}
                      onChange={(date, dateString) => {
                        setCreatedAt(
                          dateString[0] && dateString[1] ? JSON.stringify(dateString) : ""
                        );
                        setPage(1);
                      }}
                      value={parseCreatedAtRange(created_at)}
                      format={"YYYY-MM-DD"}
                      disabledDate={(current) => {
                        return moment() <= current;
                      }}
                    />
                  </div>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      variant="contained"
                      onClick={() => {
                        setSearch("");
                        setVesselId("");
                        setLocationId("");
                        setSaling_date(undefined);
                        setCreatedAt(
                          JSON.stringify([
                            moment().subtract(3, "months").format("YYYY-MM-DD"),
                            moment().format("YYYY-MM-DD"),
                          ])
                        );
                        setPage(1);
                      }}
                      style={{
                        marginRight: "10px",
                        background: "var(--red)",
                        fontWeight: "500",
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => saveDownloads()}
                      style={{
                        marginRight: "10px",
                        background: "#0ab402",
                        fontWeight: "500",
                      }}
                    >
                      Download
                    </Button>
                  </div>
                </div>

                <div className="card-body">
                  <div className="table_holder">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div
                        style={{ marginRight: "auto", marginBottom: "10px" }}
                      >
                        <MemberType
                          setVesselId={setType}
                          vesselData={vessel}
                          vesselId={type}
                          getData={getData}
                          setPage={setPage}
                          width={150}
                        />
                        <Button
                          variant="contained"
                          style={{
                            marginRight: "10px",
                            background: "Black",
                            fontWeight: "500",
                          }}
                        >
                          Number Of Bookings: {count}
                        </Button>
                      </div>
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <SearchField
                          value={search}
                          SearchValue={() => {
                            // Debouncing handled by useDebounce hook - no need for additional calls
                          }}
                          setValue={(e) => {
                            setSearch(e.target.value);
                            setPage(1); // Reset to page 1 when user searches
                          }}
                        />
                      </div>
                    </div>
                    <CustomizedTable
                      setRows={setRows}
                      setPageSize={setPageSize}
                      setPage={setPage}
                      pageSize={pageSize}
                      page={page}
                      count={count}
                      columns={columns}
                      rows={rows}
                      sortHandler={sortHandler}
                      title={"Failed Bookings"}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
        {active === "downloads" && (
          <Download
            type={"Leads"}
            slug={"/website/bookings/leads/edit/"}
            refreshlog={active}
            module={"failed_booking"}
          />
        )}
        {active === "logs" && (
          <Logs
            type={"Leads"}
            slug={"/website/bookings/leads/edit/"}
            refreshlog={active}
          />
        )}
      </div>
    </Layout>
  );
};

export default Leads;
